<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="hideOffCanvasFunc"></vk-offcanvas-close>
        <h3>Warning Info</h3>
        <hr />

        <div v-show="warningItem != null">
          <div class="inverterInfo">
            <b> DeviceID </b>
            <span>{{ warningItem && warningItem.DeviceID }}</span>
          </div>
          <div class="inverterInfo">
            <b> Name </b>
            <span>{{ warningItem && warningItem.installation.name }}</span>
          </div>
          <div class="inverterInfo">
            <b> StartTime </b>
            <span>{{ warningItem && warningItem.StartTime }}</span>
          </div>
          <div class="inverterInfo">
            <b> EndTime </b>
            <span>{{ warningItem && warningItem.EndTime }}</span>
          </div>
          <div class="inverterInfo">
            <b> Fault </b> <span>{{ warningItem && warningItem.Fault }}</span>
          </div>
          <div class="inverterInfo">
            <b> Severity </b>
            <span>{{ warningItem && warningItem.Severity }}</span>
          </div>
          <div class="inverterInfo">
            <b> Status </b> <span>{{ warningItem && warningItem.Status }}</span>
          </div>
        </div>
      </div>
    </vk-offcanvas>

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Alarms</h2>
      </div>

      <div>
        <Warnings
          @showOffCanvas="showOffCanvasFunc"
          @onRowClick="openWarningInfo"
        ></Warnings>
      </div>
    </div>
  </div>
</template>

<script>
import Warnings from "./warnings";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
export default {
  name: "",
  components: {
    Warnings,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      errors: [],
      installationOptions: [],
      showOffCanvas: false,
      warningItem: null
    };
  },
  computed: {},
  methods: {
    openWarningInfo(row) {
      this.warningItem = row;
      console.log(row);
    },
    showOffCanvasFunc() {
      this.showOffCanvas = true;
    },
    hideOffCanvasFunc() {
      this.showOffCanvas = false;
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
.inverterInfo {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/customerWarning/index.vue